var React = require('react');

function KbdOption (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 1h5.562l6.135 12.364H16V15h-5.562L4.294 2.627H0V1zm9.499 0H16v1.627H9.499V1z"}));
}

KbdOption.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = KbdOption;

KbdOption.default = KbdOption;
